//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCofig from '@/config/app'
import formatAudioTiming from '../utils/formatAudioTiming'

// 是否是H5渠道
let h5 = false

let playAudioTimer = null
export default {
  name: 'm-voice',
  data () {
    return {
      audio: AppCofig.audio,
      isPlaying: false,
      currentAudioTime: '01:11',
      h5: h5
    }
  },
  mounted () {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true
    }
  },
  computed: {
    wx () {
      if (this.isPlaying) {
        return 'static/images/wx_voice_active.gif'
      } else {
        return 'static/images/wx_voice.png'
      }
    },
    onOff () {
      if (this.isPlaying) {
        return 'static/images/audio_start.png'
      } else {
        return 'static/images/audio_pause.svg'
      }
    }
  },
  methods: {
    play () {
      this.isPlaying = !this.isPlaying
      if (this.isPlaying) {
        this.$refs.audio.play()
        playAudioTimer = setInterval(() => {
          this.currentAudioTime = formatAudioTiming(this.$refs.audio.currentTime)
          if (this.$refs.audio.ended) {
            this.isPlaying = false
            clearInterval(playAudioTimer)
          }
        }, 1000)
      } else {
        this.$refs.audio.pause()
        clearInterval(playAudioTimer)
      }
    },
    getAudioDuration () {
      if (this.h5) return
      this.currentAudioTime = formatAudioTiming(this.$refs.audio.duration)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Voice.vue